/**
 * Reports API service
 */

import apiClient from './api';
import { ReportType, Product, ExperimentVersion } from '../types';

export interface ReportRequest {
  type: ReportType;
  product: Product;
  experiment: ExperimentVersion;
}

export interface MissingPredictionsReport {
  reportType: ReportType;
  product: Product;
  experiment: ExperimentVersion;
  environment: string;
  generatedAt: string;
  totalManifestItems: number;
  missingPredictions: number;
  missingPercentage: number;
  missingItems: Array<{
    id: string;
    product_experiment: string;
    product: string;
    experiment_version: string;
    review_status: string;
    tag_prediction_type: string;
    created_at: string;
    updated_at: string;
    reviewed_by?: string[];
    feedback?: string;
    assignee?: string;
    lesson_name: string;
    lesson_number: string;
    lesson_subject: string;
    lesson_grade: number;
    lesson_pdf: string;
    unit_number: string;
    unit_name: string;
    target_cc_standard_codes?: string[];
    target_standard_ids?: string[];
    spine_tag_ids?: string[];
    missingFields: string[];
  }>;
}

export type ReportData = MissingPredictionsReport;

export interface StartReportJobResponse {
  jobId: string;
  status: string;
  message: string;
}

export const reportsApi = {
  /**
   * Start a report generation job
   */
  async startReportJob(request: ReportRequest): Promise<StartReportJobResponse> {
    const response = await apiClient.post<StartReportJobResponse>('/reports/generate', request);
    return response.data;
  },

  /**
   * Get job status and result
   */
  async getJobStatus(jobId: string): Promise<any> {
    const response = await apiClient.get(`/reports/job/${jobId}`);
    return response.data;
  },
};